import { render, staticRenderFns } from "./CenterCreateUpdate.vue?vue&type=template&id=782388ac&"
import script from "./CenterCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./CenterCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports